import './App.css';
import { Routes, Route, BrowserRouter } from "react-router-dom";

import Headers from './components/header/Header';
import WhyChoose from './components/whychoose/Whychoose';
import OurClients from './components/ourclient/Ourclient';
import Tools from './components/tools/Tools';
import CourseSyllabus from './components/CourseSyllabus/CourseSyllabus';
import Trainers from './components/trainers/Trainers';
import Timelines from './components/timelines/Timelines';
import Placement from './components/placement/Placement';
import Testimonial from './components/testimonial/Testimonial';
import Upcoming from './components/upcomingbatches/Upcoming';
import FAQ from './components/faq/FAQ';
import Contact from './components/contact/Contact';
import Footer from './components/footer/Footer';
import Project from './components/project/Project';
import OurClient from './components/ourclients/Ourclient';
import ServicesSection from './components/servicessection/Servicesection';
import Navbar from './components/navbar/Navbar';
import ThankYou from './components/thankyou/Thankyou';

function App() {
  return (
    <>
      {/* Navbar displayed on all pages */}
     <BrowserRouter>

      <Routes>

        {/* HOME PAGE */}
        <Route
          path="/"
          element={
            <>
             <Navbar />
              <Headers />
              <Project />
              <ServicesSection />
              <OurClient />
              <Tools />
              <CourseSyllabus />
              <Trainers />
              <Placement />
              <Testimonial />
              <Upcoming />
              <FAQ />
              <Contact />
              <Footer />
            </>
          }
        />

        {/* THANK YOU PAGE */}
        <Route path="/thankyou" element={<ThankYou />} />

      </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
